import React from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section className="py-24 bg-brand-dark relative overflow-hidden" id="kontakt" data-id="element-12">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-13">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-brand-accent opacity-10 blur-3xl" data-id="element-14"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-15">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-16">
          Bereit, keinen Anruf mehr zu verpassen?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-xl text-gray-300 mb-10" data-id="element-17">
          Starten Sie jetzt Ihre 4-wöchige Testphase — vollständig eingerichtet,
          ohne Risiko.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-18">
          <a href="mailto:dialog@voxspace.de?subject=Anfrage%20Test%20KI-Telefonassistent&body=Liebes%20vox%20space%20Team%2C%0A%0Aich%20m%C3%B6chte%20gerne%204%20Wochen%20testen.%0ARufen%20Sie%20mich%20zur%C3%BCck%20unter%3A%20%5BVorwahl%5D%20Rufnummer." className="bg-transparent border-2 border-white hover:bg-white hover:text-brand-dark text-white text-lg font-semibold px-10 py-5 rounded-xl transition-all transform hover:scale-105" data-id="element-19">
            Jetzt 4 Wochen testen
          </a>
        </motion.div>
      </div>
    </section>;
}